// import styles from "./Logo.module.scss";
import raffaelloLogo from "../../../../public/logo-text.svg";
import clsx from "clsx";
import Image from "next/image";
interface LogoProps {
  className?: any;
}
export const COLORS_GRADIENTS = { TOP: "#5c3df5", BOTTOM: "#b87efb" };
export default function RaffaelloText({ className }: LogoProps) {
  // const f1 = clsx(styles.f1, "bg-blue-200");
  // const f2 = clsx(styles.f2, "bg-indigo-300");
  // const f3 = clsx(styles.f3, "bg-indigo-300");
  // const f4 = clsx(styles.f4, "bg-violet-400");

  return (
    <div className={` ${className}`}>
      {/* <div className={styles.logo}> */}
      {/* <span className={f1} />
        <span className={f2} />
        <span className={f3} />
        <span className={f4} /> */}
      <Image src={raffaelloLogo} alt="Raffaello Logo" />
      {/* </div> */}
    </div>
  );
}
